(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multicolumn-slide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('multicolumn-slide')) {
    customElements.define('multicolumn-slide', class extends HTMLElement {
      connectedCallback() {
        this.initialize = this.initialize || this.init.bind(this);
        if (document.readyState === 'loading' || !window.Flickity) {
          document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (!this.isConnected || this.carousel || !window.Flickity) return;
        /*
        const track = this.querySelector('.multicolumn-slide__carousel');
        this.carousel = new window.Flickity(track, {
          cellSelector: '.multicolumn-slide__card',
          cellAlign: 'center',
          prevNextButtons: false,
          pageDots: true,
          groupCells: true,
          resize: true,
          imagesLoaded: true,
          contain: true,
          autoPlay: false,
          wrapAround: false,
          accessibility: true
        });
        this.syncDots = () => {
          const pagination = this.carousel.pageDots;
          pagination.holder.hidden = this.carousel.slides.length <= 1;
          pagination.dots.forEach((dot, index) => {
            dot.setAttribute('role', 'button');
            dot.setAttribute('tabindex', '0');
            dot.setAttribute('aria-label', this.dataset.pageLabel.replace('[number]', index + 1));
          });
        };
        this.onDotKeydown = (event) => {
          const dot = event.target.closest('.dot');
          if (!dot || !this.carousel.pageDots.holder.contains(dot)) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            this.carousel.select(this.carousel.pageDots.dots.indexOf(dot));
          }
        };
        this.onBlockSelect = (event) => {
          const card = event.target.closest('.multicolumn-slide__card');
          if (card) this.carousel.selectCell(card, false, true);
        };
        this.carousel.on('resize', this.syncDots);
        this.carousel.on('cellChange', this.syncDots);
        this.addEventListener('keydown', this.onDotKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.syncDots();
        */
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.initialize);
        this.removeEventListener('keydown', this.onDotKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.carousel) {
          this.carousel.destroy();
          this.carousel = null;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
